<template>
  <div class="choose">
    <img
      src="https://picbed.qunarzz.com/01e21b80ffe55ae0b91e1e6501a6af99.png"
      alt=""
    />
    <div @click="showWay" class="way"></div>
    <div @click="showRule" class="rule"></div>
    <div class="choose-box">
      <div @click="choose('MENGXING_PATTERN')" class="choose-item">
        <img
          class="tag"
          src="https://picbed.qunarzz.com/b95a91a257f1a36ada89aceb19eea303.png"
        />萌新模式
      </div>
      <div @click="choose('HANMI_PATTERN')" class="choose-item">
        <img
          class="tag"
          src="https://picbed.qunarzz.com/d7edf6f46e5a3ba8d6d0badf455d9a72.png"
        />韩迷模式
      </div>
      <div @click="choose('DASHEN_PATTERN')" class="choose-item">
        <img
          class="tag"
          src="https://picbed.qunarzz.com/1fa4c1e1d58c2f94e107629f044be4e5.png"
        />大神模式
      </div>
    </div>
  </div>
</template>

<script>
// import way from './dialog/way/index'
// import ruleDialog from "./dialog/rule/index";
import createAudio from './audio'
// import timerDialog from './dialog/timer/index'
export default {
  methods: {
    choose(mode) {
      createAudio('choose');
      timerDialog({
        callback:()=>{
            this.$emit("choose", mode);
        }
      })
    },
    showRule() {
      ruleDialog();
    },
    showWay() {
      way();
    },
  },
};
</script>

<style lang="less" scoped="true">
.choose {
  position: relative;
  &-box {
    position: absolute;
    left: 50%;
    top: 239px;
    margin-left: -98px;
  }
  &-item {
    width: 197px;
    height: 52px;
    margin-bottom: 31px;
    text-align: center;
    line-height: 52px;
    font-size: 25px;
    color: #fff;
    background: #5885cf;
    box-shadow: 0px 3px 4px 0px rgba(97, 142, 213, 0.58);
    border-radius: 7px;
    position: relative;
    .tag {
      height: 24px;
      position: absolute;
      left: 8px;
      top: -24px;
    }
  }
}
.way {
  position: absolute;
  left: 12px;
  top: 288px;
  width: 40px;
  height: 112px;
}
.rule {
  position: absolute;
  right: 0;
  top: 75px;
  width: 86px;
  height: 120px;
}
</style>